import { l as locales } from '../locales-DbFLN74b.js';

function convertToPantherLocale(locale = 'en-US') {
  // chrome_api: en_US / panther: en-US
  const pantherLocale = locale.replace('_', '-');
  return locales.includes(pantherLocale) ? pantherLocale : 'en-US';
}

export { convertToPantherLocale as c };
//# sourceMappingURL=convertToPantherLocale-BIgO7g9P.js.map
